module.exports = __webpack_public_path__ + "static/media/atlas-3.01736550.png";